import Errors from './Errors';

export default class Form  {

    constructor(data) {

        this.useAxios = false;
        this.multipart = false;
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
    }

    setUseAxios(){
        this.useAxios = true;
        return this
    }

    data() {
        let data = {};

        if (this.multipart) {
            data = new FormData();

            for (let prop in this.originalData) {
                data.append(prop, this[prop]);
            }
        } else {
            for (let prop in this.originalData) {
                data[prop] = this[prop];
            }
        }

        return data;
    }

    reset() {
        for (let field in this.originalData) {
            this[field] = this.originalData[field];
        }

        this.errors.clearAll();
    }

    submit(requestType, url, extraData) {

        if(this.useAxios){
            return new Promise((resolve, reject) => {
                SellsyJS.WebServiceCaller.callWebService({
                    route: url, 
                    params: extraData, 
                    data: this.data(), 
                    method: requestType, 
                    success_callback: (response) => {
                        this.onSuccess(response);
                        resolve(response)
                    }, 
                    error_callback: (error) => {
                        this.onFail(error.response.data)
                        reject(error.response.data)
                    }
                })
            })
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                method : requestType,
                url : url,
                dataType : 'json',
                data: { ...this.data(), ...extraData }
            })
            .then((response, status, jqXhr) => {
                this.onSuccess(response);
                resolve(response);
            })
            .catch((error)  => {
                this.onFail(error.responseJSON);
                reject(error.responseJSON);
            });
        });
    }

    post(url, data) {
        return this.submit('post', url, data);
    }


    put(url, data) {
        return this.submit("put", url, data);
    }

    onSuccess(data) {
        this.reset();
    }

    onFail(data) {

        const formError = data.form.msg;
        if (formError) {
            Push.error(formError);
        }

        let errors = {};
        for (let error of data.form.fields){
            errors[error.fieldId] = error.msg;
        }

        this.errors.setErrors(errors);
    }

    setMultipart() {
        this.multipart = true;
    }

    fillData(data) {
        for (let field in this.originalData) {
            if (data[field] != undefined) {
                this[field] = data[field];
            }
        }
    }
}
